import React, { useState, useEffect } from "react";
import ArrowLeft from "../../assets/svg-icons/arrowLeft";
import ArrowRight from "../../assets/svg-icons/arrowRight";
import DarkTheme from "../../assets/svg-icons/darkTheme";
import DarkThemeFilled from "../../assets/svg-icons/darkThemeFilled";
import PairDark from "../../assets/svg-icons/pairDark";
import PairLight from "../../assets/svg-icons/pairLight";
import RandomIcon from "../../assets/svg-icons/randomIcon";
import ThumbDown from "../../assets/svg-icons/thumbDown";
import ThumbUp from "../../assets/svg-icons/thumbUp";
import Sidebar from "../Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { SET_BROWSER_HISTORY } from "../../store/types/menuBar";
import DarkThemeStar from "../../assets/svg-icons/darkThemeStar";
import MonotypeLogo from "../../assets/svg-icons/brandLogo";
import {  Link, useNavigate } from "react-router-dom";
import { dispatchRandFontPair } from "../../hooks/useKeyDown";
import { deleteUser, putFonts } from "../../utils/Fonts";
import { CHANGE_THEME } from "../../store/types/theme";
import { TOOLTIP } from "../../constant";
import { IS_FONT_LOADING } from "../../store/types/font";

const Header = ({showBurgerMenu, setShowPairSec, showPairSec, hideActionBar, hideMenubar, showSidebar, setShowSidebar,likedPair, help, scrolledWeb, showSmallScrolledWeb, setLoader, canUndo, canRedo, undoDoc, redoDoc, isKeyboardOpen}) => {
  const navigate = useNavigate();
  const dislikedPairs = !localStorage.getItem("dislikedPairs") ? [] : 
                        JSON.parse(localStorage.getItem("dislikedPairs")).dislikedPairs;
  
  const { darkTheme } = useSelector((state) => state.theme)

  const dispatch = useDispatch();
  const {
    fontHeadingLock,
    fontDescriptionLock,
    currentFontPair,
    fonts,
    allPairs,
    isFontLoading
  } = useSelector((state) => state.font);
  const { isBrowserHistoryActive } = useSelector((state) => state.menuBar);
  const [newLikedPair, setnewLikedPair] = useState([]);
  const [pairsHistory, setpairsHistory] = useState([]);
  const [pairsHistoryIndex, setpairsHistoryIndex] = useState(0);

  const[like,setlike] = useState([]);
  const[dislike,setdislike] = useState([]);

  const goBackHistory = () => { 
    if (canUndo){
      undoDoc()
      navigate(-1)
    }
  }

  const goForwardHistory = () => { 
    if (canRedo) {
      redoDoc()
      navigate(1)

    }
  }

  useEffect(() => {
    if(isBrowserHistoryActive) return
    if(currentFontPair.length === 0) return
    setpairsHistory([...pairsHistory, currentFontPair])
  }, [currentFontPair, isBrowserHistoryActive])

  useEffect(() => {
    setpairsHistoryIndex(pairsHistory.length)
    dispatch({ type: SET_BROWSER_HISTORY, payload: false })
  },[pairsHistory, fontHeadingLock, fontDescriptionLock, dispatch])

  useEffect(() => {
    setnewLikedPair(likedPair)
  }, [likedPair])
  

  const { liked  } = useSelector((state) => state.menuBar);
  const handleOpenSidebar = () => {
    setShowSidebar(!showSidebar);
    setShowPairSec(false);
  }
  const handlePairToggle = () => {
    setShowPairSec(!showPairSec)
  }
  const handleSwitchTheme = () => {
    dispatch({ type: CHANGE_THEME, payload: !darkTheme })
  }

  const indexofLikedPair = newLikedPair && Array.isArray(newLikedPair) && newLikedPair.findIndex((item) => item?.likedPair?.toString() === currentFontPair?.toString());

  const indexofDisLikedPair = dislikedPairs && Array.isArray(dislikedPairs) && dislikedPairs.findIndex((item) => item?.dislikedPair?.toString() === currentFontPair?.toString());
  
  const thumbDownHandler = async () => {

    setlike(false)
    const disliked = { dislikedPair: currentFontPair }
    if(indexofDisLikedPair !== -1) {
      const payload = {
        dislikedPairs: dislikedPairs?.filter((item) => item?.dislikedPair?.toString() !== currentFontPair?.toString())
      }
      localStorage.setItem("dislikedPairs", JSON.stringify(payload))
      deleteUser({ dislikedPairs: payload });
    }
    const payload = {
      dislikedPairs: !localStorage.getItem("dislikedPairs") ? [disliked] : [...dislikedPairs, disliked ]
    }
    if(indexofDisLikedPair === -1)
    localStorage.setItem("dislikedPairs", JSON.stringify(payload))
    const oldLikedPair = Array.isArray(newLikedPair) ? newLikedPair : [];
    const filterArray = newLikedPair?.filter((item) => item?.likedPair?.toString() !== currentFontPair?.toString())
    setnewLikedPair(filterArray)
    const { success } = await deleteUser({ likedPairs: filterArray });
    if(!success) setnewLikedPair(oldLikedPair)
    deleteUser({ dislikedPairs: payload });
    // setLoader(false)
  }

  const thumbsUpHandler = async () => {
    setlike((indexofLikedPair === -1 || typeof indexofLikedPair === "undefined"))
    if(indexofLikedPair !== -1) {
      const oldLikedPair = Array.isArray(newLikedPair) ? newLikedPair : [];
      const filterArray = newLikedPair?.filter((item) => item?.likedPair?.toString() !== currentFontPair?.toString())
      const { success } = await deleteUser({ likedPairs: filterArray });
      if(!success) {
        setnewLikedPair(oldLikedPair)
        setlike(false)
        return
      } 
      setnewLikedPair(filterArray)
      setlike(false)
    }
    
    const payload = {
      dislikedPairs: dislikedPairs?.filter((item) => item?.dislikedPair?.toString() !== currentFontPair?.toString())
    }
    localStorage.setItem("dislikedPairs", JSON.stringify(payload))
    
    if(indexofLikedPair === -1 || typeof indexofLikedPair === "undefined")  {
      setnewLikedPair(await putFonts(currentFontPair,payload.dislikedPairs))
    }
    setlike(false)
  }

  useEffect(() => {
    if(scrolledWeb || showSmallScrolledWeb) {
      setShowPairSec(false)
    }
  }, [scrolledWeb, showSmallScrolledWeb, dispatch, setShowPairSec])

  
  return (
    <>
    <div className={`page-header ${hideActionBar} ${showBurgerMenu}`}>
      <div className="page-header__inner">
        <div className="header-left">
          {
            hideMenubar ? 
            <div
              className="burger-menu"
            >
              <span />
              <span />
            </div>
            :
            <div
              className={showSidebar ? "burger-menu activeSidebar" : "burger-menu"}
              onClick={handleOpenSidebar}
            >
              <span />
              <span />
            </div>
          }
          <div className="brand-logo">
            <Link to="/" title="Monotype" aria-label="Monotype" onClick={() => setShowSidebar(false)}><MonotypeLogo /></Link>
          </div>
        </div>
        <div className={showSidebar ? "header-right hide-header" : "header-right"}>
          <div className="thumb-icons">
            <span className="GA_thumbsUp">
            <ThumbUp
              liked={!help ? (like | (typeof indexofLikedPair === "undefined" ? false : (indexofLikedPair === -1 ? false : true))) : false}
              onClick={thumbsUpHandler}
            />
            </span>
            <span className="GA_thumbsDown">
            <ThumbDown
              disliked={ !help ? (dislike | (typeof indexofDisLikedPair === "undefined" ? false : (indexofDisLikedPair === -1 ? false : true))) : false }
              onClick={thumbDownHandler}
            />
            </span>
            <div className="tutorial-content-box">
              <p>
              To like a pair, press thumbs up; to dislike a pair, press thumbs down.
              </p>
              <span className="dashed-linebar" />
            </div>
          </div>
          <div className="switch-icons">
            <span className="GA_arrowLeft">
            <ArrowLeft canUndo={canUndo} onClick={goBackHistory}/>
            </span>
            <span className="GA_arrowRight">
            <ArrowRight canRedo={canRedo} onClick={goForwardHistory}/>
            </span>
          </div>
          <div className={darkTheme ? "theme-switch showDark-theme GA_themeSwitch" : "theme-switch GA_themeSwitch"} onClick={handleSwitchTheme}>
            <DarkTheme />
            <DarkThemeFilled />
            <DarkThemeStar />
          </div>
          <div title={TOOLTIP.MORE_PAIRS} className={!showPairSec ? "pair-icons GA_morePairs" : "pair-icons activePair GA_morePairs"}>
            <button onClick={handlePairToggle}><PairLight /> <PairDark /> More pairs</button>
            <div className="tutorial-content-box">
              <p>
              To see hand-curated pairs, select More pairs.
              </p>
              <span className="dashed-linebar"></span>
            </div>
          </div>
          <div title = {TOOLTIP.RANDOMISE} className="randoms-buttons GA_randomButton">
            <button type="button"
              className={`btn btn-random ${isFontLoading ? 'is-disabled' : ''}`}
              onClick={() => {
                dispatch({ type: IS_FONT_LOADING, payload: true });
                dispatchRandFontPair({dispatch, fontHeadingLock,
                  fontDescriptionLock,
                  currentFontPair,
                  allPairs, fonts ,isBrowserHistoryActive})
                }
              }>
              <RandomIcon />
              Generate pair
            </button>
            <div className="tutorial-content-box">
              <p>
              To jump to the next pair, press randomise.
              </p>
              <span className="dashed-linebar"></span>
            </div>
          </div>
        </div>
      </div>
      <div
        className={showSidebar ? "page-sidebar show-sidebar" : "page-sidebar"}
      >
        <Sidebar setShowSidebar={setShowSidebar} />
      </div>
      { isKeyboardOpen === '' && 
          <div className="mobile-icon-footer">
            <div className="thumb-icons">
              <span className='GA_thumbsUp'>
              <ThumbUp
                liked={!help ? (like | (typeof indexofLikedPair === "undefined" ? false : (indexofLikedPair === -1 ? false : true))) : false}
                onClick={thumbsUpHandler}
              />
              </span>
              <span className='GA_thumbsDown'>
              <ThumbDown
                disliked={ !help ? (dislike | (typeof indexofDisLikedPair === "undefined" ? false : (indexofDisLikedPair === -1 ? false : true))) : false }
                onClick={thumbDownHandler}
              />
              </span>
            </div>

            <div  title = {TOOLTIP.RANDOMISE} className="randoms-buttons  GA_randomButton">
              <button type="button"
                className={`btn btn-random ${isFontLoading ? 'is-disabled' : ''}`}
                onClick={() => {
                  dispatch({ type: IS_FONT_LOADING, payload: true });
                  dispatchRandFontPair({dispatch, fontHeadingLock,
                  fontDescriptionLock,
                  currentFontPair,
                  allPairs,
                  fonts, isBrowserHistoryActive})
                }}>
              <RandomIcon />
              Generate pair
              </button>
            </div>

            <div className="switch-icons">
              <span className="GA_arrowLeft">
                <ArrowLeft canUndo={canUndo} onClick={goBackHistory}/>
                </span>
                <span className="GA_arrowRight">
                <ArrowRight canRedo={canRedo} onClick={goForwardHistory}/>
                </span>
            </div>
          </div>
          }
    </div>
    </>
  );
};

export default Header;
